var map = {
	"./gmail_imagotype.png": "f414",
	"./gmail_logo.png": "8940",
	"./google_integration_graphic.png": "0f2e",
	"./google_logo.png": "34fe",
	"./microsoft_imagotype.png": "c979",
	"./microsoft_integration_graphic.png": "5200",
	"./microsoft_logo.png": "6e89"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "27c4";